import { render } from "./LedgerEdit.vue?vue&type=template&id=9e4efad6"
import script from "./LedgerEdit.vue?vue&type=script&lang=js"
export * from "./LedgerEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__